// solarSystem.js
var SolarSystem = pc.createScript('solarSystem');

SolarSystem.attributes.add('hotRockPlanet', {type: 'entity'});
SolarSystem.attributes.add('coldRockPlanet', {type: 'entity'});
SolarSystem.attributes.add('hotGasGiant', {type: 'entity'});
SolarSystem.attributes.add('coldGasGiant', {type: 'entity'});
SolarSystem.attributes.add('normalGasGiant', {type: 'entity'});
SolarSystem.attributes.add('habitablePlanet', {type: 'entity'});
SolarSystem.attributes.add('habitablePlanetOcean', {type: 'entity'});
SolarSystem.attributes.add('inHabitableRockplanet', {type: 'entity'});
SolarSystem.attributes.add('maxPlanets', {type: 'number'});
SolarSystem.attributes.add('baryCenter', {type: 'entity', title: 'barycenter'});
SolarSystem.attributes.add('systems', {type: 'entity', array: true, title: 'starSystemLayouts'});
SolarSystem.attributes.add('dSystems', {type: 'entity', array: true, title: 'dysonSystemLayouts'});
SolarSystem.attributes.add('planetTag', {type: 'entity'});
SolarSystem.attributes.add('tScreen', {type: 'entity'});
SolarSystem.attributes.add('planetButtons', {type: 'entity'});
SolarSystem.attributes.add('infinityButton', {type: 'entity'});
SolarSystem.attributes.add('genButton', {type:'entity'});

// initialize code called once per entity
SolarSystem.prototype.initialize = function() {    
    
    this.seedScript = this.app.root.findByName('SEEDER').script.seeder;
    this.theSeed = 0.0;
    this.randomize = 0.0;
    this.oldSeed = 0;
    
    this.kIIevent = false;
    this.kIIraisingProb = 0;
    this.kIIcounter = 0;

    this.numberPlanets = 0;
    this.numberSuns = 0;
    this.trinaryLayout = 0;
    this.lastPlanetX = 0;
    this.range = 'hot';
    this.planetPool = new Array(0);
    this.instancePlanets = this.app.root.findByTag('instancePlanets');
    this.tagPool = new Array(0);
    this.planetData = new Array(0);
    this.systemType = null;
    this.app.on('planetLoaded:Planet', this.planetSequenceLoader, this);
    this.app.on('planetGenerator:addMaterial', this.addMaterial, this);
    this.app.on('hover:generatorTrigger', this.kickOff, this);
    this.app.on('orbitCam:SolarGen:focusAtUrlStart', this.orbitInit, this);
  //  this.app.on('solarSystem:allPlanets', this.markUrlPlanet, this);
    this.app.on('orbitCam:SolarGen:quickButton', this.quickButton, this);
    this.app.on('userInput:objectSelected', this.setNewTarget, this);
    this.loadedInd = 0;
    this.dysonSystems = this.app.root.findByName('dysonSystems');
    this.dtp = [];
    this.filteredList = [];
    this.matList = [];
    this.uiGen = this.app.root.findByName('additionalUI').script.uiGenerator;
    this.planetPositions = [];
    this.theSystem = null;
    this.firstTime = true;
    this.crossSection = this.app.root.findByName('crossSection');
    
    this.infinityButton.button.active = false;
        
    this.url = new URL(window.top.location.href);
    this.urlseed = this.url.searchParams.get('s');
    this.autoPlay = this.url.searchParams.get('ap');
    this.planetCamInd = this.url.searchParams.get('p');
    this.urlStart = false;
    this.planetType = null;
    this.urlPlanet = null;
    this.newTarget = null;
    this.inputField = this.app.root.findByName('inputField');
    this.fwa = this.app.root.findByName('fwa');
    this.cam = this.app.root.findByName('Camera');
    this.camScript = this.cam.script.orbitCamera;
    
    this.infinityButton.script.infinityButton.enabled = false;
    this.infinityButton.button.active = false;

    this.tCont = this.app.root.findByName('specialLogoContainer');
   // this.slScript = this.tCont.script.specialLogos;

    if(this.urlseed !== null){
        this.urlStart = true;
    }

};

SolarSystem.prototype.quickButton = function() {
    
    if(!this.urlStart){
        return;
    }
    if(this.urlPlanet === undefined){
        return;
    }
 
   // this.app.fire('userInput:objectSelected', this.urlPlanet.children[1]);
    this.app.fire('userInput:test', this.urlPlanet.children[1]);
    this.cam.script.cameraController.planetCounter = this.planetCamInd;
    this.urlStart = false;
};

SolarSystem.prototype.setNewTarget = function(ent){
    this.newTarget = ent;
};

SolarSystem.prototype.orbitInit = function(){
        

    if(!this.urlStart){
        return;
    } else {

    }

   // console.log('ORBITINIT: ' + this.urlPlanet);

    this.fwa.element.enabled = false;
    this.urlPlanet = this.planetPool[this.planetCamInd-1];
    
    if(this.urlPlanet === undefined){

        this.camScript.resetAndLookAtPoint(this.cam, this.theSystem.getLocalPosition());

        var ts = this;
        //FOR RADIO PURPOSES - TRIGGERS RELOAD INFINITY RESTART
        if(this.autoPlay !== undefined){
         
            if(this.numberPlanets == 0){
           
                this.cam.script.cameraController.noPlanets = true;
                this.cam.script.cameraController.waitForPlanets = false;
            }
            setTimeout(function(){
                //console.log('TIMEOUT');
                ts.cam.script.cameraController.theSystem = ts.theSystem;
                ts.infinityButton.script.infinityButton.up();
                
            },5000);
        }

        this.app.fire('userInput:objectSelected', this.theSystem);
        this.app.fire('userInput:test', this.theSystem);
        return;
    }
    
    this.planetType = this.urlPlanet.name;
    this.setMinMax();
    
    if(this.planetCamInd > -1 && this.planetCamInd < this.planetPool.length){
        this.cam.script.cameraController.planetCounter = this.planetCamInd;
        this.camScript.resetAndLookAtPoint(this.cam, this.urlPlanet.children[1].getLocalPosition());       
    } else {
        
    }
//    console.log('FIRE');

    this.app.fire('userInput:objectSelected', this.urlPlanet.children[1]);

   // console.log('this.ap: ' + this.autoPlay);



};

SolarSystem.prototype.kickOff = function(){

    this.infinityButton.script.infinityButton.enabled = false;
    this.infinityButton.button.active = false;
    this.genButton.element.enabled = false;
    this.genButton.button.active = false;
    this.genButton.children[0].enabled = true;
    
    this.app.fire('responsiveHandler:resetStartconditions');
    this.planetPositions = [];
    this.loadedInd = 0;
    this.app.fire('systemGenerator:reset');
    this.reset();
};

SolarSystem.prototype.addMaterial = function(mat) {
    this.matList.push(mat);
};


SolarSystem.prototype.planetSequenceLoader = function() {
    
    var typ = null;
        if(this.planetPool.length !== 0){
            
            if(this.loadedInd < this.planetPool.length){
                
            var nm = this.planetPool[this.loadedInd].children[1].children[1].name;
            var uVar = this.randomize();
                
            if(nm == 'hotRockPlanet' || nm == 'coldRockPlanet' ||  nm == 'proceduralPlanet'){
                var pScrpt = this.planetPool[this.loadedInd].children[1].children[1].script.planetGenerator;
                pScrpt.theSeed = uVar;
                pScrpt.start();
                typ = 'rockPlanet';
                this.app.fire('solarGen:PlanetInfoSpawn', this.planetPool[this.loadedInd]);
            } else if(nm == 'hotGasGiant' || nm == 'coldGasGiant') {
                var gScrpt = this.planetPool[this.loadedInd].children[1].children[1].script.gasGiantGenerator;
                gScrpt.theSeed = uVar;
                gScrpt.trigger();
                typ = 'gasGiant';  
                this.app.fire('solarGen:PlanetInfoSpawn', this.planetPool[this.loadedInd]);
            }
            
            // console.log('loadedInd: ' + this.loadedInd + ' pplength: ' + this.planetPool.length);
            // console.info(this.planetPool[this.loadedInd].name);
            // // console.info(this.planetPool);
           // console.log('psl: ' + this.loadedInd + ' tp: ' + typ);

        }
       
    }
    if (this.loadedInd == this.planetPool.length) {
       //console.log('urlstart: ' + this.urlStart + ' urlplanet: ' + this.urlPlanet);
       //console.log('ALL PLANETS LOADED, LOADEDIND: ' + this.loadedInd + ' LENGTH: ' + this.planetPool.length);
        this.infinityButton.button.active = true;
        this.infinityButton.script.infinityButton.enabled = true;
        //console.log('active' + this.infinityButton.button.active);
        this.genButton.element.enabled = true;
        this.genButton.button.active = true;
        this.genButton.children[0].enabled = false;
       
        if(this.urlStart){
            this.app.fire('solarSystem:planetList', this.planetPositions, this.theSystem);
        }
        
       this.app.fire('solarSystem:allPlanets', this.planetPositions, this.theSystem);

        if(this.urlStart && this.urlPlanet !== undefined && this.numberPlanets !== 0){

            //console.log('urlP: ' + this.urlPlanet);
            this.app.fire('solarSystem:urlPlanet', this.urlPlanet.children[1]);
            
            //this.app.fire('solarSystem:urlPlanet', this.urlPlanet.children[1]);
            this.urlPlanet = null;
            this.urlStart = false;
            
        } else if(this.urlStart && this.urlPlanet === undefined){
            
            var sr = null;
            if(this.newTarget !== null){
                sr = this.newTarget;
            } else {
                sr = this.theSystem;
            }
            
            this.app.fire('solarSystem:urlPlanet', sr);  
            this.urlPlanet = null;
            this.urlStart = false; 
            this.newTarget = 0;
            
        } else if(!this.urlStart && this.urlPlanet === undefined || !this.urlStart && this.urlPlanet === null) {

            var tr = null;
            if(this.newTarget !== null){
                tr = this.newTarget;
            } else {
                tr = this.theSystem;
            }

            if(this.urlPlanet === null){
                tr = this.theSystem;
            }

            this.app.fire('userInput:test', tr);
            this.urlPlanet = null;
            this.newTarget = 0;
        }
         
    } else {
        this.loadedInd += 1;
    }
    // console.log('solar:plntSequence:seed: ' + this.theSeed);
    
};

SolarSystem.prototype.setRandoms = function() {
    if(this.kIIevent){
        this.numberPlanets = Math.floor(this.randomize() * 3) + 8;
        return;
    }
    this.numberPlanets = Math.floor(this.randomize() * this.maxPlanets); // number of planets in system
};


SolarSystem.prototype.calcPlanets = function () {
   // console.log('solar:calcPlanets:seed: ' + this.theSeed);
    this.app.fire('solarGen:SystemInfo', this.numberPlanets, this.systemType);
    var sunMinDistance = 150;
    this.range = 'hot';
    this.lastplanetX = 0;
        
    for(var l = 0; l < this.numberPlanets; l++){

        var plnt = null;
        var cCln = this.baryCenter.clone();
        var rot = 0;
        var xPos = 0;
       
        this.app.root.addChild(cCln);
        cCln.name = 'planet';
        cCln.tag = 'planet';
        
        if(this.range == 'hot'){
            if(this.randomize() > 0.5){
                plnt = this.hotGasGiant.clone();
            } else {
                plnt = this.hotRockPlanet.clone();
            }
        }
        
        if(this.range == 'habitable'){
            var medRnd = this.randomize();
            if(medRnd > 0 && medRnd < 0.25){
                plnt = this.habitablePlanet.clone();
            } else if (medRnd > 0.25 && medRnd < 0.5){
                plnt = this.habitablePlanetOcean.clone();
            } else if (medRnd > 0.5 && medRnd < 0.76){
                plnt = this.normalGasGiant.clone();
            } else if (medRnd > 0.75){
                plnt = this.inHabitableRockplanet.clone();
            }
        }
        
        if(this.range == 'cold'){
            if(this.randomize() > 0.5){
                plnt = this.coldRockPlanet.clone();
            } else {
                plnt = this.coldGasGiant.clone();
            }
        }
        cCln.addChild(plnt);
        cCln.enabled = true;
        this.planetPool.push(cCln);
        if(this.kIIevent){
            var scrpt = cCln.children[1].children[1].script;
            if(scrpt.gasGiantGenerator){
                scrpt.gasGiantGenerator.stationProb = 10;
            } else if (scrpt.planetGenerator){
                if(scrpt.planetGenerator.civProb > 0){
                    scrpt.planetGenerator.civProb = 10;
                    scrpt.planetGenerator.civStellar = 10;
                    scrpt.planetGenerator.civInterStellar = 10;
                    //scrpt.planetGenerator.civStation = 10;
                }
            }
        }
      
         
        if(l === 0){
            plnt.setLocalPosition(sunMinDistance, 0,0);
            rot = Math.floor(this.randomize() * 360);
            cCln.setEulerAngles(0,rot,0); 
            this.lastPlanetX = sunMinDistance;
        } else {
            xPos = this.lastPlanetX + this.randomize() * 25 + 25;
            rot = Math.floor(this.randomize() * 360);
            plnt.setLocalPosition(xPos, 0,0);
            cCln.setEulerAngles(0,rot,0);
            this.lastPlanetX = plnt.getLocalPosition().x;
        }
        
        if(this.lastPlanetX > 200 && this.lastPlanetX < 250){
            this.range = 'habitable';
        } else if (this.lastPlanetX > 350){
            this.range = 'cold';
        }
        
        
      
        this.planetPositions.push(plnt);
        
       // console.log(plnt.findByName('moons'));   
        var m = plnt.findByName('moons');
        if(m){
            m.script.moonGenerator.ind = l;
            m.script.moonGenerator.go();
        }
       
        var newTag = this.planetTag.clone();
        newTag.enabled = true;
        this.tScreen.addChild(newTag);
        newTag.children[1].children[1].element.text = plnt.name + '\n' + plnt.children[1].name;
        newTag.name = 'planet' + l;
        newTag.script.planetTagger.setTarget(plnt);
        this.tagPool.push(newTag);
    }
    this.lastplanetX = 0;

    for(var lp = 0; lp < this.instancePlanets.length; lp++){
        this.instancePlanets[lp].enabled = false;
    }
    

        this.app.fire('solarSystem:planetList', this.planetPositions, this.theSystem);

  
  this.planetSequenceLoader();

};


SolarSystem.prototype.setSuns = function (){
    
    var rsys = Math.floor(this.randomize() * this.dSystems.length);
    if(this.kIIevent){
      if(this.dSystems.length > 0){
          this.dSystems[rsys].enabled = true;
          this.systemType = 'DYSON GENERATOR';
          this.tagSystem(this.dSystems[rsys]);
          this.theSystem = this.dSystems[rsys];
          //console.log(this.dSystems[rsys].children[this.dSystems[rsys].children.length-1].name);
      }
        if(!this.urlStart){
            this.urlPlanet = undefined;
            this.app.fire('userInput:objectSelected', this.theSystem);
        }
        return;
    }
    
    var starSystemProb = this.randomize();
    if(starSystemProb > 0.42 && starSystemProb < 0.85){
        if(this.randomize() > 0.5){
            this.systems[1].enabled = true;
            this.systemType = 'BINARY';
            this.tagSystem(this.systems[1]);
            this.theSystem = this.systems[1];
        } else {
            this.systems[5].enabled = true;
            this.systemType = 'X-RAY BINARY';
            this.tagSystem(this.systems[5]);   
            this.theSystem = this.systems[5];
        }
    } else if(starSystemProb < 0.42) {
        if(this.numberPlanets > 0){
            this.systems[0].enabled = true;
            this.systemType = 'SINGULAR';
            this.tagSystem(this.systems[0]);
            this.theSystem = this.systems[0];
        } else {
            if(this.randomize() > 0.5) {
                this.systems[0].enabled = true;
                this.systemType = 'SINGULAR';
                this.tagSystem(this.systems[0]);
                this.theSystem = this.systems[0];
            } else {
                this.systems[4].enabled = true;
                this.systemType = 'SINGULAR';
                this.systems[4].children[2].enabled = true;
                this.app.fire('solarGen:setStarter');
                this.systems[4].children[2].script.k3Generator.setK3();
                this.tagSystem(this.systems[4]);
                this.theSystem = this.systems[4];
            }
        }
    } else if(starSystemProb > 0.85){
        if(this.randomize() > 0.5) {
            this.systems[2].enabled = true;
            this.tagSystem(this.systems[2]);
            this.theSystem = this.systems[2];
            this.systemType = 'TRINARY';
        } else {
            this.systems[3].enabled = true;
            this.tagSystem(this.systems[3]);
            this.theSystem = this.systems[3];
            this.systemType = 'TRINARY';
        }
    }
    
    if(!this.urlStart){
        this.urlPlanet = undefined;
        this.app.fire('userInput:objectSelected', this.theSystem);       
    }
    
};

SolarSystem.prototype.tagSystem = function(sys) {
        
        this.app.fire('solarGen:ActualSystem', sys);
        var newSysTag = this.planetTag.clone();
        newSysTag.enabled = true;
        this.tScreen.addChild(newSysTag);
        newSysTag.children[1].children[1].element.text = sys.name;
        newSysTag.name = 'system';
        newSysTag.script.planetTagger.setTarget(sys);
        this.tagPool.push(newSysTag); 
    
};

SolarSystem.prototype.reset = function() {
    var self = this;
    //console.log('------------------------------');
    
    if(this.crossSection.enabled){
        this.crossSection.enabled = false;
    }
    
//     this.cam.enabled = false;
//    // this.cam.script.bloom.enabled = false;
//     this.sysIntroCam.enabled = true;
//   //  this.sysIntroCam.script.bloom.enabled = true;
    
//     setTimeout(function(){
//         self.cam.enabled = true;
//       //  self.cam.script.bloom.enabled = true;
//         self.sysIntroCam.enabled = false;
//        // self.sysIntroCam.script.bloom.enabled = false;
//      },3000);
    
    this.planetPositions = [];
    this.kIIevent = false;
    this.app.fire('systemGenerator:kill');

    //GET GLOBAL SEED AND SET RANDOMIZE OBJECT
    this.seedScript.reset();
    this.theSeed = this.seedScript.seed;
    this.randomize = new Math.seedrandom(this.seedScript.getUniqueRandom());

    for(var ip = 0; ip < this.instancePlanets.length; ip++){
        this.instancePlanets[ip].enabled = true;
    }
    
    var system = this.app.root.findByTag('system');
    for(var k = 0; k < system.length; k++){
        system[k].enabled = false;
    }
    
    var delTex = this.app.assets.findByTag('dynamic');
    if(delTex.length !== 0){
        for(var dt = 0; dt < delTex.length; dt++){
                delTex[dt].unload();
        }
    }

    for(mat = 0; mat < this.matList.length; mat++){
       this.matList[mat].destroy();
     }

    for (var j = 0; j < this.planetPool.length; j++){
        this.planetPool[j].destroy();
    }

    for (var t = 0; t < this.tagPool.length; t++){
        this.tagPool[t].destroy();
    }
    
    this.matList = [];
    this.tagPool = [];
    this.planetPool = [];
    
    if(this.randomize() > 0.9){
      //  console.log('dyson true');
        this.dysonSystems.enabled = true;
        this.kIIevent = true;
    } else {
      //  console.log('dyson false');
        this.dysonSystems.enabled = false;
        this.kIIevent = false;
    }

    this.setRandoms();
    this.setSuns();
    this.calcPlanets();
};

SolarSystem.prototype.setMinMax = function(){
    if(this.planetType === 'system'){
       // console.log('QUICKLINK:PLANETMINMAX_S');
        this.camScript.distanceMin = 1000;
        this.camScript.distanceMax = 2500;
    } else if(this.planetType === 'rockPlanet'){
      //  console.log('QUICKLINK:PLANETMINMAX_R');
        this.camScript.distanceMin = 150;
        this.camScript.distanceMax = 200;
    } else if (this.planetType === 'gasGiant'){
       // console.log('QUICKLINK:PLANETMINMAX_G');
        this.camScript.distanceMin = 350;
        this.camScript.distanceMax = 600;
    } else if(this.planetType === 'habitable'){
     //   console.log('QUICKLINK:PLANETMINMAX_H');
        this.camScript.distanceMin = 150;
        this.camScript.distanceMax = 200;
    }
};

// update code called every frame
SolarSystem.prototype.update = function(dt) {
    // if (this.app.keyboard.wasReleased(pc.KEY_SPACE)) {
    //   //  console.log('fire!');
    //     this.app.fire('responsiveHandler:resetStartconditions');
    //     this.loadedInd = 0;
    //     this.plantePositions = [];
    //     this.app.fire('systemGenerator:reset');
    //     this.reset();
    // }
    
    if (this.app.keyboard.wasReleased(pc.KEY_ENTER)) {
      //  console.log('fire!');
        var inp = this.inputField.script.input.getValue();
        var sed = this.seedScript.seed;
        if(inp === sed){
            return;
        }
        this.app.fire('responsiveHandler:resetStartconditions');
        this.loadedInd = 0;
        this.plantePositions = [];
        this.app.fire('systemGenerator:reset');
        this.reset();
    }
    
};

// swap method called for script hot-reloading
// inherit your script state here
// SolarSystem.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// http://developer.playcanvas.com/en/user-manual/scripting/

